<template>
  <cookie-law theme="gwf" transitionName="fade" storageType="cookie" :message="message" :buttonText="buttonText">
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  computed: {
    message() {
      return this.$t('mygwf.components.Guest.privacy_cookie.message')
    },
    buttonText() {
      return this.$t('mygwf.components.Guest.privacy_cookie.button_text')
    },
  },
  components: {
    CookieLaw,
  },
}
</script>

<style>
.Cookie {
  @apply bg-white border text-sm w-full p-3;

  position: fixed;
  overflow: hidden;
  left: 0 !important;
  box-sizing: border-box;
  z-index: 1000;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
}
@screen lg {
  .Cookie {
    @apply max-w-xl p-4;
  }
}

.Cookie__button {
  @apply bg-primary text-white transition duration-100 ease-linear;

  padding: 0.625em 3.125em;
}
.Cookie__button:hover {
  @apply bg-primary-light;
}
.Cookie__button:focus {
  @apply outline-none ring;
}
.Cookie__content {
  @apply mr-6;
}
.Cookie--gwf {
}
.Cookie--gwf .Cookie__button {
}
.Cookie--gwf div.Cookie__button:hover {
}
</style>
